var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "divBox" },
    [
      _c(
        "el-card",
        { staticClass: "box-card" },
        [
          _c(
            "el-form",
            {
              ref: "pram",
              attrs: {
                model: _vm.pram,
                rules: _vm.rules,
                "label-width": "100px",
              },
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: "管理员账号", prop: "account" } },
                [
                  _c("el-input", {
                    attrs: { placeholder: "管理员账号", disabled: true },
                    model: {
                      value: _vm.pram.account,
                      callback: function ($$v) {
                        _vm.$set(_vm.pram, "account", $$v)
                      },
                      expression: "pram.account",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "管理员姓名", prop: "realName" } },
                [
                  _c("el-input", {
                    attrs: { placeholder: "管理员姓名", required: true },
                    model: {
                      value: _vm.pram.realName,
                      callback: function ($$v) {
                        _vm.$set(
                          _vm.pram,
                          "realName",
                          typeof $$v === "string" ? $$v.trim() : $$v
                        )
                      },
                      expression: "pram.realName",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                [
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary" },
                      on: {
                        click: function ($event) {
                          return _vm.handlerSubmit("pram")
                        },
                      },
                    },
                    [_vm._v("提交")]
                  ),
                  _c(
                    "el-button",
                    {
                      on: {
                        click: function ($event) {
                          return _vm.close("pram")
                        },
                      },
                    },
                    [_vm._v("取消")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }